<template>
  <v-bottom-sheet :value="value" @input="$emit('input', $event)" dark inset>
    <v-sheet class="text-center" rounded="t-xl" style="background-color: #1e1e1e">
      <v-tabs v-model="tab" background-color="#272727" grow>
        <v-tab> Gelesen ({{ readByList.length }}) </v-tab>
        <v-tab> Noch nicht ({{ notReadByList.length }}) </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab" style="background-color: transparent">
        <v-tab-item>
          <v-list dark color="transparent" v-if="readByList.length > 0">
            <v-list-item v-for="receipt in sortedReadBy" :key="receipt.userId._id">
              <v-list-item-avatar>
                <v-img v-if="receipt.userId.bild" :src="'/img/profilbilder/' + receipt.userId.bild"></v-img>
                <span v-else>{{ getInitials(receipt.userId) }}</span>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title> {{ receipt.userId.vorname }} {{ receipt.userId.nachname }} </v-list-item-title>
                <v-list-item-subtitle>
                  {{ formatReadTime(receipt.readAt) }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <div v-else class="pa-4 grey--text">Noch von niemandem gelesen.</div>
        </v-tab-item>

        <v-tab-item>
          <v-list dark color="transparent" v-if="notReadByList.length > 0">
            <v-list-item v-for="member in notReadByList" :key="member.userId._id">
              <v-list-item-avatar>
                <v-img v-if="member.userId.bild" :src="'/img/profilbilder/' + member.userId.bild"></v-img>
                <span v-else>{{ getInitials(member.userId) }}</span>
              </v-list-item-avatar>

              <v-list-item-content class="text-left">
                <v-list-item-title> {{ member.userId.vorname }} {{ member.userId.nachname }} </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <div v-else class="pa-4 grey--text">Von allen gelesen.</div>
        </v-tab-item>
      </v-tabs-items>

      <v-btn text color="grey" @click="$emit('input', false)" class="my-2"> Schließen </v-btn>
    </v-sheet>
  </v-bottom-sheet>
</template>

<script>
import { mapState } from "vuex"

export default {
  name: "ReadReceiptsDialog",
  props: {
    value: Boolean, // v-model
    readBy: {
      // Das 'message.readBy'-Array
      type: Array,
      default: () => [],
    },
    members: {
      // NEU: Das 'activeGroupData.members'-Array
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      tab: 0, // Startet auf dem "Gelesen"-Tab
    }
  },
  computed: {
    // Holt den eingeloggten User, um ihn rauszufiltern
    ...mapState("userStore", ["user"]),

    // Stellt sicher, dass 'readBy' einheitliche Objekte hat
    readByList() {
      return this.readBy || []
    },

    // Sortiert die "Gelesen"-Liste
    sortedReadBy() {
      return [...this.readByList].sort((a, b) => new Date(b.readAt) - new Date(a.readAt))
    },

    // NEU: Berechnet, wer noch fehlt
    notReadByList() {
      if (!this.members || !this.user) return []

      // 1. Hol alle IDs derer, die gelesen haben
      const readerIds = new Set(this.readByList.map((receipt) => receipt.userId._id || receipt.userId))

      // 2. Filtere die Mitgliederliste
      return this.members.filter((member) => {
        // 3. Zeige nicht dich selbst
        if (member.userId._id === this.user._id) return false
        // 4. Zeige nur die, die NICHT in der 'readerIds'-Liste sind
        return !readerIds.has(member.userId._id)
      })
    },
  },
  methods: {
    getInitials(user) {
      if (!user) return "?"
      const v = user.vorname || ""
      const n = user.nachname || ""
      return `${v.charAt(0).toUpperCase()}${n.charAt(0).toUpperCase()}`
    },

    formatReadTime(timestamp) {
      const date = new Date(timestamp)
      // TODO: Bessere Datums-Formatierung (z.B. "Heute um 14:31")
      return date.toLocaleString("de-CH", {
        dateStyle: "short",
        timeStyle: "short",
      })
    },
  },
}
</script>
